import { AxiosInstance } from "axios";
import { Account } from "types/account";
import { queryOne } from "utils/rest/restApi";

export const getAccount = (axios: AxiosInstance): Promise<Account> => {
  return queryOne<Account>(axios, "account");
};
